import Vue from 'vue'
import YimoVueEditor from 'yimo-vue-editor'
import Cookie from 'js-cookie'

Vue.use(YimoVueEditor, {
  name: 'v-editor',//Custom name
  config: {
    uploadImgUrl:'/api/file/uploadfile', // upload api
    uploadHeaders:{
      'Authorization': Cookie.get('Authorization')
    },
    printLog: false, // disabled console.log
    useLang: 'en' // lang config
  },//wagnEditor config
  uploadHandler: (type, resTxt) => {//Upload processing hook
    console.log(type, resTxt)
    if (type === 'success') {
      var res = JSON.parse(resTxt)//Do not process the default look at the return value bit image path
      if (res.status !== 200) {
        return null
      }
      return res.data.filePath
    } else if (type === 'error') {
      //todo toast
    } else if (type === 'timeout') {
      //todo toast
    }
    return 'upload failed__'
  }
})